import constant from './constant';

/**
 * @param lazyImage
 * @param stateClass
 */
const clearDataSrc = (lazyImage: Element, stateClass: string) => {
  lazyImage.classList.add(stateClass);

  lazyImage.removeAttribute('data-src');
  lazyImage.removeAttribute('data-err');
};

const lazyImageObserver = new IntersectionObserver((entries) => {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      const lazyImage = entry.target;
      lazyImage.classList.add(constant._V_LOADING);

      const dataSrc = (lazyImage as any).dataset.src;
      const dataErr = (lazyImage as any).dataset.err;

      const newImage = new Image();
      newImage.src = dataSrc;
      // success
      /**
       *
       */
      newImage.onload = () => {
        lazyImage.classList.remove(constant._V_LOADING);

        if (dataSrc) {
          (lazyImage as any).src = dataSrc;
          clearDataSrc(lazyImage, constant._V_LOADED);
        }
      };
      // error
      /**
       *
       */
      newImage.onerror = () => {
        lazyImage.classList.remove(constant._V_LOADING);

        if (dataErr) {
          (lazyImage as any).src = dataErr;
          clearDataSrc(lazyImage, constant._V_ERROR);
        }
      };

      lazyImageObserver.unobserve(lazyImage);
    }
  });
});

export default lazyImageObserver;
